import React from "react";
import {useHistory} from "react-router-dom";
import Notification from "@source/components/snackMessage/notification";
import {HOME_ROUTES} from "@source/utils/utils";
import {CategoryForm} from "../consentCategories/categoryForm";

export const NewCategory = ({organizationId, canReadTemplates}: {organizationId: string; canReadTemplates: boolean}) => {
  const history = useHistory();
  return <CategoryForm organizationId={organizationId} canReadTemplates={canReadTemplates} onSaved={() => { new Notification().success("Consent Category created."); history.push(HOME_ROUTES.ConsentDocumentsCategories); }}/>;
};

